module.exports = __webpack_public_path__ + "img/hero-dintica.ee711312.png";